import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./components/Login";
import Autores from "./components/Autores";
import MenuReferencias from "./components/MenuReferencias";
import ProtectedRoute from "./components/ProtectedRoute";

import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import VerifyEmail from "./pages/VerifyEmail";
import ContratoWizard from "./pages/contratos/ContratoWizard";
import ContratosList from "./pages/contratos/ContratosList";
import Reportar from "./pages/Reportar";
import ConsultarPuntajeArrendatario from "./pages/ConsultarPuntajeArrendatario";
import AdministrarBienesInmuebles from "./pages/AdministrarBienesInmuebles";
import ConsultarBienesInmuebles from "./pages/ConsultarBienesInmuebles";
import CrearPersona from "./pages/CrearPersona";
import Parametrizacion from "./pages/Parametrizacion";
import ConsentBanner from "./components/ConsentBanner";


const RootRedirect = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  if (!token) {
    if (window.location.hostname.includes("mereferencio")) {
      return <Navigate to="/login-arrendatario" />;
    }
    return <Navigate to="/login" />;
  }
  if (role === "ARRENDATARIO") return <Navigate to="/consultar-puntaje" />;
  return <Navigate to="/referencias" />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Página raíz */}
        <Route path="/" element={<RootRedirect />} />

        {/* Login / Registro / Recuperación */}
        <Route path="/login" element={<Login />} />
        <Route path="/login-arrendatario" element={<Login isArrendatarioRoute={true} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot" element={<ForgotPassword />} />

        {/* Autores */}
        <Route
          path="/autores"
          element={
            <ProtectedRoute allowedRoles={["ADMINISTRADOR"]}>
              <Autores />
            </ProtectedRoute>
          }
        />

        {/* Menú principal */}
        <Route
          path="/referencias"
          element={
            <ProtectedRoute>
              <MenuReferencias />
            </ProtectedRoute>
          }
        />

        {/* 🔥 GESTIÓN DE CONTRATOS Y ADMINISTRADOR DE PAGOS */}
        <Route
          path="/contratos"
          element={
            <ProtectedRoute allowedRoles={["ADMINISTRADOR", "ARRENDADOR"]}>
              <ContratosList />
            </ProtectedRoute>
          }
        />

        {/* 🔥 NUEVA RUTA: Crear Contrato */}
        <Route
          path="/contratos/nuevo"
          element={
            <ProtectedRoute allowedRoles={["ADMINISTRADOR", "ARRENDADOR"]}>
              <ContratoWizard />
            </ProtectedRoute>
          }
        />

        {/* 🔥 NUEVA RUTA: Reportar Novedad */}
        <Route
          path="/reportar"
          element={
            <ProtectedRoute allowedRoles={["ADMINISTRADOR", "ARRENDADOR"]}>
              <Reportar />
            </ProtectedRoute>
          }
        />

        {/* 🔥 NUEVA RUTA: Consultar Puntaje del Arrendatario */}
        <Route
          path="/consultar-puntaje"
          element={
            <ProtectedRoute allowedRoles={["ADMINISTRADOR", "ARRENDADOR", "ARRENDATARIO"]}>
              <ConsultarPuntajeArrendatario />
            </ProtectedRoute>
          }
        />

        <Route
          path="/parametrizacion"
          element={
            <ProtectedRoute allowedRoles={["ADMINISTRADOR", "ARRENDADOR"]}>
              <Parametrizacion />
            </ProtectedRoute>
          }
        />

        <Route
          path="/inmuebles/administrar"
          element={
            <ProtectedRoute allowedRoles={["ADMINISTRADOR", "ARRENDADOR"]}>
              <AdministrarBienesInmuebles />
            </ProtectedRoute>
          }
        />

        <Route
          path="/personas/crear"
          element={
            <ProtectedRoute allowedRoles={["ADMINISTRADOR", "ARRENDADOR"]}>
              <CrearPersona />
            </ProtectedRoute>
          }
        />

        <Route
          path="/inmuebles/consultar"
          element={
            <ProtectedRoute allowedRoles={["ADMINISTRADOR", "ARRENDADOR", "ARRENDATARIO"]}>
              <ConsultarBienesInmuebles />
            </ProtectedRoute>
          }
        />

      </Routes>
      <ConsentBanner />
    </BrowserRouter>
  );
}

export default App;
